export const applicationStatus = {
  PENDING: {
    className: "text-status-pending bg-yellow-100",
    label: "Pending",
  },
  IN_PROGRESS: {
    className: "text-status-progress bg-emerald-100",
    label: "In Progress",
  },
  FORM_FILL_PENDING: {
    className: "text-status-formfillpending bg-violet-100",
    label: "Form Fill Pending",
  },
  FORM_FILL_IN_PROGRESS: {
    className: "text-status-formfillprogress bg-violet-100",
    label: "Form Fill In Progress",
  },
  REJECT: {
    className: "text-status-reject bg-red-100",
    label: "Reject",
  },
  VERIFY: {
    className: "text-status-verify bg-green-200",
    label: "Login Done",
  },
  GENERATE: {
    className: "text-status-generate bg-orange-100",
    label: "Generate",
  },
  DONE: {
    className: "text-status-done bg-cyan-100",
    label: "Done",
  },
  CANCELLED: {
    className: "text-status-cancelled  bg-black-100",
    label: "Cancelled",
  },
};
